<template>
  <Button v-bind="$attrs" data-cy="upload-button" @click="inputRef?.click()" />
  <input
    id="file-upload"
    ref="inputRef"
    :key="key"
    accept=".json"
    type="file"
    data-cy="json-upload-input"
    @change="processJson"
    @select="key++"
  />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useJsonParser } from "@/composables/jsonParser";
import { useOnline } from "@vueuse/core";

const emit = defineEmits(["submitted"]);

const { processJson, jsonString, error } = useJsonParser();
const online = useOnline();
const inputRef = ref<HTMLInputElement>();
const key = ref(1);
// emit json string after verification, then clear
watch(jsonString, unwrappedJsonString => {
  if (!unwrappedJsonString) return;

  emit("submitted", unwrappedJsonString);
  jsonString.value = undefined;
});
</script>

<style lang="scss" scoped>
input[type="file"] {
  display: none;
}
</style>
